import TextInput from "@gx/dls/inputs/TextInput";

interface CreateSourceNameInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  isDisabled?: boolean;
}

const CreateSourceNameInput = ({
  value,
  onChange,
  error,
  isDisabled = false,
}: CreateSourceNameInputProps) => {
  return (
    <TextInput
      label="Source name"
      labelTooltip="Give your data source a descriptive name to help identify it."
      value={value}
      onChange={onChange}
      placeholder="Enter source name..."
      error={error ?? undefined}
      isDisabled={isDisabled}
      isRequired
      fillWidth
      autoFocus
    />
  );
};

export default CreateSourceNameInput;
